import React, { useRef } from 'react';
import { Input, useToast } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { FirstStepTaskOverlay } from 'components/TaskOverlay/FirstStepTaskOverlay';
import { List } from 'components/List';
import { ListItem } from 'components/ListItem';
import { ListItemMainText } from 'components/ListItem/ListItemMainText';
import { UploadIcon } from 'components/icons';

const MAX_UPLOAD_FILES = 32;

export interface EditorAttachmentModalInput {
  fileUploadTokens?: string[];
  documentTitle?: string;
  url?: string;
  onComplete?(): void;
}
interface EditorAttachmentModalProps {
  isOpen: boolean;
  onClose(): void;
  onUploadFile(files: File[], pageId: string): void;
  pageId: string;
}

export const EditorAttachmentModal = ({
  isOpen,
  onClose,
  onUploadFile,
  pageId,
}: EditorAttachmentModalProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const toast = useToast();

  const openLocalFileSelector = () => {
    fileInputRef?.current?.click();
  };

  return (
    <>
      <Input
        hidden
        type="file"
        multiple
        ref={fileInputRef}
        onChange={({ target }) => {
          const files = Array.from(target?.files || []);
          let allFiles = [...files];
          if (allFiles.length > MAX_UPLOAD_FILES) {
            toast({
              title: t`You can only upload maximum of ${MAX_UPLOAD_FILES} at a time`,
              status: 'error',
            });
            allFiles = allFiles.slice(0, MAX_UPLOAD_FILES);
          }

          onUploadFile(allFiles, pageId);
          onClose();
        }}
      />
      <FirstStepTaskOverlay
        title={t`Add Files`}
        isOpen={isOpen}
        onClose={onClose}
      >
        <List withDivider>
          <ListItem
            variant="navigation"
            ariaLabel={t`Upload files`}
            icon={<UploadIcon variant="Large" color="blue.500" />}
            onClick={openLocalFileSelector}
          >
            <ListItemMainText>{t`Upload files`}</ListItemMainText>
          </ListItem>
        </List>
      </FirstStepTaskOverlay>
    </>
  );
};
